<template>
  <FriedList class="section-list">
    <li
      v-for="(section, index) of sections"
      :key="section.id"
      :class="[
        'section-list-item',
        {
          selected: isInView(section.id),
          'is-first': sections.length > 1 && section.id === sections[0].id,
          'is-last': sections.length > 1 && section.id === sections[sections.length - 1].id,
        },
      ]"
      :data-index-section-number="index"
      @click.stop="navigateToSection(section.id)"
    >
      <div class="section-list-item-container">
        <FriedIcon
          v-if="recipientHasAccessToContractLinkInSection(section, participant)"
          icon="contracts"
          class="contract-link-icon"
        />
        <NameInput
          class="section-name"
          :value="section.displayName || t('dsr_untitled_section')"
          :disabled="true"
          :title="section.displayName"
          :data-external="`dsr-published-navigation-section-id-${section.id}-name-input`"
        />
      </div>
    </li>
  </FriedList>
</template>
<script lang="ts">
import { toRefs, defineComponent } from 'vue';
import type { PropType } from 'vue';
import type { Section } from '@getaccept/editor-lib-new';
import { storeToRefs } from 'pinia';
import NameInput from '@getaccept/dsr-shared-new/src/components/NameInput.vue';
import { ContractHelper } from '@getaccept/editor-lib-new';
import type { Participant } from '@getaccept/dsr-shared-new';
import { useVisibilityStore } from '@getaccept/dsr-shared-new';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'SectionList',
  components: {
    NameInput,
  },
  props: {
    contentId: {
      type: String as PropType<string>,
      required: true,
    },
    sections: {
      type: Array as PropType<Section[]>,
      default: () => [],
    },
    participant: {
      type: Object as PropType<Participant>,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const { contentId } = toRefs(props);
    const visibilityStore = useVisibilityStore();
    const { visibleSections } = storeToRefs(visibilityStore);

    const isInView = (id: string) => visibleSections.value.includes(id);
    const navigateToSection = (sectionId: string) => {
      emit('navigate-to-section', { contentId: contentId.value, sectionId });
    };

    return {
      navigateToSection,
      isInView,
      recipientHasAccessToContractLinkInSection:
        ContractHelper.recipientHasAccessToContractLinkInSection,
      hasAccessToContractLink: ContractHelper.hasAccessToContractLink,
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/dsr-shared-new/src/scss/section-list';

.contract-link-icon {
  margin-right: var(--spacing-50);
}
</style>
